<template>
    <v-dialog
        v-model="open"
        persistent
        max-width="1024px"
        scrollable
        content-class="tw-rounded-3xl"
        >
        <v-form
            ref="form_dooway"
            v-model="valid"
            :disabled="form_loading"
            lazy-validation
            enctype="multipart/form-data"
            @submit.prevent="onSubmit"
        >
            <v-card class="tw-rounded-3xl tw-border-0 tw-shadow-md">
            <ModalHeader @close-modal="closeModal">HTML</ModalHeader>
            <v-card-text class="tw-max-h-[700px] tw-overflow-y-auto tw-p-0">
                <v-responsive class="tw-py-0">
                    <v-container class="tw-bg-gray-100 tw-w-full">
                        <v-row class="mb-3">
                            <v-col cols="12" md="6" class="mx-auto">
                                <p class="tw-text-sm tw-font-bold tw-m-0 tw-px-4">Head</p>
                                <EditorCodemirror
                                    v-if="open"
                                    v-model="html_head"
                                    class="tw-h-72 tw-rounded-xl lg:tw-h-80 2xl:tw-h-160"
                                    :options="cmOptions"
                                />
                            </v-col>
                            <v-col cols="12" md="6" class="mx-auto">
                                <p class="tw-text-sm tw-font-bold tw-m-0 tw-px-4">Body</p>
                                <EditorCodemirror 
                                    v-if="open"
                                    v-model="html_body"
                                    class="tw-h-72 tw-rounded-xl lg:tw-h-80 2xl:tw-h-160"
                                    :options="cmOptions"
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-responsive>
            </v-card-text>
            <v-card-actions>
                <v-alert
                    v-model="alert"
                    dismissible
                    color="red"
                    border="left"
                    elevation="2"
                    colored-border
                    icon="error"
                    transition="fade-transition"
                >
                    {{ errorMsg }}
                </v-alert>

                <v-spacer />
                    <v-btn
                        color="blue darken-1"
                        text
                        rounded
                        :disabled="form_loading"
                        class="tw-px-8 tw-normal-case focus:tw-outline-none focus:tw-ring focus:tw-ring-white"
                        @click="open = false"
                    >
                        Cancelar
                    </v-btn>
                    <v-btn
                        color="primary darken-1"
                        rounded
                        type="submit"
                        :loading="form_loading"
                        class="text--white text--lighten-4 tw-px-8 tw-normal-case focus:tw-outline-none focus:tw-ring focus:tw-ring-primary-300"
                    >
                        Guardar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
        </v-dialog>
</template>

<script>
import ModalHeader from '@/components/ModalHeader'

import 'codemirror/mode/htmlmixed/htmlmixed.js'
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/material.css'
import EditorCodemirror from '@/components/FormInputs/EditorCodemirror'
export default {
  components: {
    EditorCodemirror,
    ModalHeader,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    htmlHead: {
      type: String,
      default: '',
    },
    htmlBody: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    cmOptions: {
      tabSize: 4,
      mode: 'htmlmixed',
      theme: 'material',
      lineNumbers: true,
      line: true,
      lineWrapping: true,
      autoRefresh: true,
      matchBrackets: true,
    },
    errorMsg: '',
    alert: false,
    form_loading: false,
    valid: true,
  }),
  computed: {
    html_head: {
      get() {
        return this.htmlHead
      },
      set(newValue) {
        this.$emit('update:htmlHead', newValue)
      },
    },
    html_body: {
      get() {
        return this.htmlBody
      },
      set(newValue) {
        this.$emit('update:htmlBody', newValue)
      },
    },
    open: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  methods: {
    onSubmit() {
      this.open = false
    },
    closeModal() {
      this.open = false
    },
  },
}
</script>
